import styles from "./footer.module.css";

function Footer() {
  // const copyright = `© ${} `;

  return (
    <section className={styles["footer-section"]}>
      <footer className={styles["footer"]}>
        <div className={styles["contact"]}>
          <h1 className={styles["contact-h1"]}>Contáctanos:</h1>
          <h2 className={styles["email-h2"]}>ask.gotlim@outlook.com</h2>
        </div>
        <p>© {new Date().getFullYear()} Gotlim. All rights reserved.</p>
      </footer>
    </section>
  );
}

export default Footer;
